import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'src/app/hooks';
import { useGetRoomCategoriesQuery } from 'src/features/manage-room/manage-room.slice';
import { store } from 'src/app/store';
import { setRoomCategories } from 'src/app/reducers/manage-room.reducer';
import { StyledTagDescription, StyledTagsHeading } from '../../categories-tab.styles';
import { CategoryTagsCard } from '../category-tags-card';
import { StyledMitreTagsContainer, StyledRoomCategoryWrapper } from './room-categories.styles';
export const RoomCategories = () => {
  const {
    roomCode
  } = useParams();
  const roomCategories = useAppSelector(state => state.manageRoom.roomCategories.categories);
  const {
    data,
    isFetching
  } = useGetRoomCategoriesQuery({
    roomCode: (roomCode as string)
  });
  useEffect(() => {
    store.dispatch(setRoomCategories(data?.data ?? []));
  }, [data?.data, isFetching]);
  return <StyledMitreTagsContainer data-sentry-element="StyledMitreTagsContainer" data-sentry-component="RoomCategories" data-sentry-source-file="room-categories.tsx">
      <StyledTagsHeading data-sentry-element="StyledTagsHeading" data-sentry-source-file="room-categories.tsx">MITRE category tags</StyledTagsHeading>
      <StyledTagDescription data-sentry-element="StyledTagDescription" data-sentry-source-file="room-categories.tsx">Choose the topics found in your room.</StyledTagDescription>

      <StyledRoomCategoryWrapper data-sentry-element="StyledRoomCategoryWrapper" data-sentry-source-file="room-categories.tsx">
        {Object.values(roomCategories).map(category => <CategoryTagsCard key={category._id} category={category} isCategoryAdded />)}
      </StyledRoomCategoryWrapper>
    </StyledMitreTagsContainer>;
};